<template>
  <modal :show="show" :on-close="close">
    <div class="modal-header">
      <h3>{{ header }}</h3>
    </div>

    <div class="modal-body">
      <label class="form-label">
        Name
        <input v-model="name" class="form-control text-right" />
      </label>
      <label class="form-label">
        Quota
        <input v-model="quota" type="number" min="0" class="form-control text-right" />
      </label>
      <br />
      <!-- FIXME - This should be tabbable -->
      <div class="daysControl form-label">
        <template v-for="day in weekdays">
          <input type="checkbox" :id="day" :value="day" v-model="activeDays" />
          <label :for="day" :key="day">{{ day }}</label>
        </template>
      </div>
      <div class="colorControl flexRow form-label">
        <template v-for="(hex, colorName) in colors">
          <input
            type="radio"
            class="form-control text-right"
            name="colorSelect"
            v-model="color"
            :id="colorName"
            :value="colorName"
            :key="colorName"
          />
          <label :for="colorName" :style="'background-color:' + hex" />
        </template>
      </div>
      <!-- FIXME - Better UI, please! -->
      <!-- FIXME - Better UI, please! -->
      <label class="form-label" v-if="Object.keys(children).length == 0">
        Parent Category
        <select v-model="parentId" class="form-control text-right">
          <option value=""></option>
          <option v-for="(category, id) in parentEligibleCategories" :value="id" :key="id">
            {{ category }}
          </option>
        </select>
      </label>
      <div class="form-label" v-if="Object.keys(children).length != 0">
        This category is already the parent to another category.
      </div>
      <label class="form-label">
        Order Weight
        <input v-model="orderImportance" class="form-control text-right" />
      </label>
    </div>

    <div class="modal-footer">
      <button class="modal-default-button" @click="close">
        Cancel
      </button>
      <!-- FIXME - This should be tabbable -->
      <archive-category :categoryId="categoryId" v-if="!isNew" />
      <delete-category :categoryId="categoryId" v-if="!isNew" />
      <button class="modal-default-button" @click="save">
        Save
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal.vue";
import ArchiveCategory from "./ArchiveCategory.vue";
import DeleteCategory from "./DeleteCategory.vue";

import db from "../db.js";
import util from "../util.js";
import eventHub from "../eventHub.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "category-modal",
  components: {
    modal: Modal,
    "archive-category": ArchiveCategory,
    "delete-category": DeleteCategory,
  },
  props: ["show", "categories"],
  data() {
    return {
      modalType: "edit", // Default to edit?
      categoryId: "",
      name: "",
      color: "",
      quota: 1,
      activeDays: util.getWeekDays(),
      parentId: "",
      children: {},
      orderImportance: 0,
    };
  },
  created() {
    eventHub.$on("show-category-modal", this.populateModalAndShow);
  },
  methods: {
    populateModalAndShow(data) {
      this.$set(this, "modalType", data.modalType);

      const id = data.categoryId;
      const category = categoryUtil.getCategory(id);

      this.$set(this, "name", id ? categoryUtil.getName(id) : data.name);

      if (!this.isNew) {
        this.$set(this, "quota", category.quota);
        this.$set(this, "color", category.color);
        this.$set(this, "categoryId", category.id);
        this.$set(this, "activeDays", category.activeDays || []);
        this.$set(this, "parentId", category.parentId || "");
        this.$set(this, "children", category.children ? category.children : []);
        this.$set(this, "orderImportance", category.orderImportance ? category.orderImportance : 0);
      }

      eventHub.$emit("set-category-modal-visibility", { isVisible: true });
    },
    close() {
      // TODO - Refactor to initial state function
      // FIXME - Seriously - this is too many lines of duplicated code
      this.$set(this, "name", "");
      this.$set(this, "quota", 1);
      this.$set(this, "color", util.getDefaultBlockColor());
      this.$set(this, "activeDays", util.getWeekDays());
      this.$set(this, "categoryId", "");
      this.$set(this, "parentId", "");
      this.$set(this, "children", []);
      this.$set(this, "orderImportance", 0);
      eventHub.$emit("set-category-modal-visibility", { isVisible: false });
    },
    save() {
      this.isNew ? this.saveNew() : this.saveEdits();
    },
    saveNew() {
      const parentId = this.parentId;
      db.userRef("categories")
        .push({
          name: this.name,
          quota: typeof this.quota == "number" ? this.quota : 1,
          color: this.color,
          activeDays: this.activeDays,
          created: Date.now(),
          updated: Date.now(),
          parentId: this.parentId,
          orderImportance: this.orderImportance,
        })
        .then(function(snapshot) {
          const key = snapshot.key;
          // FIXME - MOVE TO DB
          if (parentId != "") {
            db.userRef("categories/" + parentId + "/children")
              .child(key)
              .set({
                added: Date.now(),
              });
          }
        });

      ga("send", "event", "categories", "new", this.parentId != "" ? "child" : "parent");

      this.close();
    },
    saveEdits() {
      db.userRef("categories/" + this.categoryId).update({
        "/color": this.color,
        "/name": this.name,
        "/quota": parseInt(this.quota),
        "/updated": Date.now(),
        "/activeDays": this.activeDays || [],
        "/parentId": this.parentId,
        "/orderImportance": this.orderImportance,
      });

      //FIXME - Undo previous parent relationships here, please!
      // db.userRef("categories/" + this.parentId + "/children")
      //     .child(this.blockId)
      //     .remove();
      if (this.parentId != "") {
        db.userRef("categories/" + this.parentId + "/children")
          .child(this.categoryId)
          .set({
            added: Date.now(),
          });
      } else {
        db.userRef("categories/" + this.parentId + "/children")
          .child(this.categoryId)
          .remove();
      }

      ga("send", "event", "categories", "update", this.parentId != "" ? "child" : "parent");

      this.close();
    },
  },
  computed: {
    weekdays() {
      return util.getWeekDays();
    },
    header() {
      return this.isNew ? "New Category" : "Edit Category";
    },
    isNew() {
      return this.modalType == "new";
    },
    colors() {
      return util.colors;
    },
    parentEligibleCategories() {
      let eligibleParents = {};
      for (let categoryId in this.categories) {
        if (categoryId == this.categoryId) {
          continue;
        }

        let category = this.categories[categoryId];
        // In theory these should be the same check...
        if (!category.parentId || category.parentId.length == 0) {
          eligibleParents[categoryId] = category.name;
        }
      }
      return eligibleParents;
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  display: none;
}

input[type="radio"] + label {
  width: 0.75rem;
  height: 0.75rem;
  margin: 0.25rem 0.125rem;
  border: 1px solid #333;
  display: inline-block;
}

input[type="radio"]:checked + label {
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"] + label {
  margin: 0.125rem;
}

input[type="checkbox"]:checked + label {
  color: #3498db;
}
</style>



// WEBPACK FOOTER //
// CategoryModal.vue?e003ff8a